import React from "react";
import HeadingDate from "./HeadingDate";

const ResultTable = ({results, filterByDate}) => {
    const date = results.length === 0 ? filterByDate : results[0]?.drawAt;

    return <div id="result">
        <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
                <thead>
                <tr>
                    <HeadingDate date={date}/>
                </tr>
                <tr>
                    <th width="300">ម៉ោងចេញឆ្នោត</th>
                    <th width="300">រង្វាន់: A</th>
                    <th width="300">រង្វាន់: B</th>
                    <th width="300">រង្វាន់: C</th>
                    <th width="300">រង្វាន់: D</th>
                </tr>
                </thead>
                <tbody>
                {results.map((r, i) => (
                    <tr key={i}>
                        <td>{r.drawLabel}</td>
                        <td>{r.postA}</td>
                        <td>{r.postB}</td>
                        <td>{r.postC}</td>
                        <td>{r.postD}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    </div>
}

export default ResultTable;